<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-text-field
                        label="Поиск"
                        placeholder="Адрес"
                        outlined
                        v-model="filter.search"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="debtorsItems"
                        disable-pagination
                        class="elevation-1"
                        hide-default-footer
                    >
                        <template v-slot:top>
                        <v-toolbar
                            flat
                        >
                            <v-toolbar-title>Должники</v-toolbar-title>
                            <v-divider
                                class="mx-4"
                                inset
                                vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="IS_ADMIN"
                                color="primary"
                                dark
                                class="mb-2 mr-2"
                                @click="$router.push({name: 'SocialDebtorsUploadPage'})"
                            >
                                Загрузить
                            </v-btn>
                            <v-dialog
                                v-model="dialog"
                                max-width="800px"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    dark
                                    class="mb-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    Добавить
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                <span class="text-h5">Добавление должника</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-form
                                        ref="form"
                                        v-model="valid"
                                        lazy-validation
                                    >
                                        <v-container>
                                            <v-row>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="4"
                                                >
                                                    <v-text-field
                                                        v-model="editedItem.last_name"
                                                        label="Фамилия"
                                                        placeholder="Фамилия"
                                                        :rules="[v => !!v || 'Обязательно для заполнения',]"
                                                        required
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="4"
                                                >
                                                    <v-text-field
                                                        v-model="editedItem.first_name"
                                                        label="Имя"
                                                        placeholder="Имя"
                                                        :rules="[v => !!v || 'Обязательно для заполнения',]"
                                                        required
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="4"
                                                >
                                                    <v-text-field
                                                        v-model="editedItem.middle_name"
                                                        label="Отчество"
                                                        placeholder="Отчество"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="4"
                                                >
                                                    <v-text-field
                                                        v-model="editedItem.judgment_number"
                                                        label="Номер судебного решения"
                                                        placeholder="Номер судебного решения"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="6"
                                                >
                                                    <v-menu
                                                        v-model="menuDatepicker"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="editedItem.date_of_judgment"
                                                            label="Дата судебного приказа"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="editedItem.date_of_judgment"
                                                            @input="menuDatepicker = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                
                                                <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="12"
                                                >
                                                    <label>Выберите объект управления:</label>
                                                    <v-autocomplete
                                                        ref="autocomplete_house_object"
                                                        @click="onClickSelectObjects"
                                                        @click:append="onClicklAutocompleteAppendHouseObjects"
                                                        @click:clear="onClickSelectObjects"
                                                        no-filter
                                                        outlined
                                                        dense
                                                        clearable
                                                        :validate-on-blur="true"
                                                        v-model="selected_house_address_object_id"
                                                        :loading="searchHouseObjectLoading"
                                                        :items="houseObjects"
                                                        :search-input.sync="searchHouseObject"
                                                        class="mx-4"
                                                        hide-no-data
                                                        hide-details
                                                        placeholder="Выберите объект"
                                                        item-text="housingFundObject_address"
                                                        return-object
                                                        :rules="[v => !!v || 'Обязательно для заполнения',]"
                                                        required
                                                    >
                                                    <template v-slot:append-item>
                                                        <div v-intersect="endIntersect" />
                                                    </template>
                                                    </v-autocomplete>
                                                </v-col>
                                               <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="12"
                                                >
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="6"
                                                        >
                                                            <label>Выберете квартиру из базы данных:</label>
                                                            <v-autocomplete
                                                                :disabled="selected_house_address_object_id == null"
                                                                clearable
                                                                :validate-on-blur="true"
                                                                v-model="editedItem.house_address_object_id"
                                                                :items="selected_house_address_object_premise_id"
                                                                class="mx-4"
                                                                outlined
                                                                dense
                                                                placeholder="Выберете квартиру"
                                                                hide-no-data
                                                                hide-details
                                                                item-text="housingFundObject_addressDetails"
                                                                item-value="id"
                                                                :rules="[v => !!v || 'Обязательно для заполнения',]"
                                                                required
                                                            >
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    <label>Если вы не нашли в списке квартиру, то добавьте ее в список вручную.</label>
                                                    <v-row>
                                                       <v-col
                                                            cols="4"
                                                            sm="4"
                                                            md="4"
                                                        >
                                                            <v-text-field
                                                                v-model="newAddresDetailsPrefix"
                                                                label="Выберите префикс"
                                                                placeholder="Введите префикс"
                                                                dense
                                                                outlined
                                                                clearable
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            sm="4"
                                                            md="4"
                                                        >
                                                            <v-text-field
                                                                v-model="newAddresDetails"
                                                                label="Введите номер помещения"
                                                                placeholder="Введите номер помещения"
                                                                dense
                                                                outlined
                                                                clearable
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            sm="4"
                                                            md="4"
                                                        >
                                                            <v-btn color="primary" @click="storeNewPremise">Добавить помещение</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-card-text>

                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="onCloseDialog"
                                >
                                    Отмена
                                </v-btn>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="onValidateAndSaveDebtor"
                                >
                                    Сохранить
                                </v-btn>
                                </v-card-actions>
                            </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card>
                                    <v-card-title class="text-h5">Удалить должника?</v-card-title>
                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Отмена</v-btn>
                                    <v-btn color="blue darken-1" text @click="onDelete(deleteHousePersonDebtorId)">OK</v-btn>
                                    <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogSaveConfirm.status" max-width="500px">
                                <v-card>
                                    <v-card-title class="text-h5">Предупреждение!</v-card-title>
                                    <v-card-text style="font-size:120%;color:black">
                                        {{dialogSaveConfirm.text}}
                                         <br/><br/> Все равно продолжить?
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialogSaveConfirm.status = false">Отмена</v-btn>
                                        <v-btn v-if="!editedItem.id" color="blue darken-1" text @click="onSaveDebtor">Продолжить</v-btn>
                                        <v-btn v-if="editedItem.id" color="blue darken-1" text @click="onUpdateDebtor">Продолжить</v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                                class="mr-3"
                                @click="onDeleteConfirm(item.id)"
                            >
                                mdi-delete
                            </v-icon>
                            <v-icon
                                class="mr-3"
                                @click="onEditDebtor(item.id)"
                            >
                                mdi-eye
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="text-center">
                        <v-pagination
                            :disabled="isFetchResults"
                            v-model="meta.current_page"
                            :length="meta.last_page"
                            total-visible="25"
                            @input="onPaginate"
                        ></v-pagination>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<style scoped>
    label {
        display: inline-block !important;
    }
</style>
<script>
import {mapGetters, mapActions} from 'vuex';
import * as organizationApi from '@/api/organizations';
import _ from 'lodash';
export default {
    props:{
    },
    name: 'SocialDebtorsPage',
    components:{
    },
    data(){
        return {
            menuDatepicker: false,
            newAddresDetails: null,
            newAddresDetailsPrefix: 'кв.',
            selected_house_address_object_id: null,
            selected_house_address_object_premise_id: [],
            houseObjectPremises: [],
            deleteHousePersonDebtorId: null,
            dialogDelete: false, 
            dialogSaveConfirm:{
                status: false,
                text: ''
            },
            searchHouseObjectLoading: false,
            searchHouseObject: null,
            houseObjects: [],
            valid: true,
            dialog: false,
            editedItem: {
                first_name: '',
                last_name: '',
                middle_name: '',
                house_address_object_id: null,
                judgment_number: null,
                date_of_judgment: null,
            },
            isFetchResults: false,
            debtors : [],
            headers: [
                { text: 'id', value: 'id' },
                { text: 'ФИО', value: 'fio' },
                { text: 'Адрес', value: 'address' },
                { text: 'Дата судебного решения', value: 'date_of_judgment' },
                { text: 'Номер судебного решения', value: 'judgment_number' },
                { text: 'Действия', value: 'actions' },
            ],
            meta: {
                current_page: 1
            },
            metaSearchHouseObjects: {
                current_page: 1
            },
            filter: {
                search: null
            }
        }
    },
    created(){
        this.loadDebtors();
    },
    watch: {
        selected_house_address_object_id (newValue) { 
            this.houseObjectPremises.splice(0, this.houseObjectPremises.length);
            this.selected_house_address_object_premise_id = null;
            if(typeof newValue === 'object' && newValue !== null){
                this.loadHouseObjectPremises();
            }
        },
        dialog: function(newVal){
            if(newVal === false){
                this.editedItem = {
                    first_name: '',
                    last_name: '',
                    middle_name: '',
                    house_address_object_id: null,
                    judgment_number: null,
                    date_of_judgment: null,
                };
                this.selected_house_address_object_id = null;
            }
        },
        searchHouseObject: _.throttle(function(newVal){
            if(newVal !== this.selected_house_address_object_id?.full_address){
                this.searchHouseObjects(this.getSearchParamsHouseObjects());
            }
            
        }, 2000),
        ORGANIZATION_ID () { 
            this.loadDebtors();
        },
        filter: {
            handler() {
                this.meta.current_page = 1;
                this.onFilter();
            },
            deep: true
        },
    },
    methods: {
        onClicklAutocompleteAppendHouseObjects(){
            this.onClickSelectObjects().then(() => {
                this.$refs["autocomplete_house_object"].focus();
                this.$refs["autocomplete_house_object"].activateMenu()
            });
        },
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
        onFilter: _.throttle(function(){
            this.loadDebtors()
        }, 2000),
        async onClickSelectObjects(){
            return this.searchHouseObjects(this.getSearchParamsHouseObjects());
        },
        endIntersect(entries, observer, isIntersecting){
            if(isIntersecting){
                this.loadNextHouseObjects();
            }
        },
        async storeNewPremise(){
            if(this.selected_house_address_object_id == null){
                this.SHOW_ERROR('Объект не выбран');
                return ;
            }
            if( this.newAddresDetails == null){
                this.SHOW_ERROR('Введите номер помещения');
                return ;
            }
            try{
                let { data } = await organizationApi.houseObjectPremiseStore(
                    this.ID_WORK_SPACE, 
                    this.ORGANIZATION_ID, 
                    this.selected_house_address_object_id.housingFundObject_fiasHouseGUID,
                    this.newAddresDetailsPrefix != null ? this.newAddresDetailsPrefix + " " + this.newAddresDetails : this.newAddresDetails
                );
                // this.selected_house_address_object_premise_id.push(data);
                await this.loadHouseObjectPremises();
                this.editedItem.house_address_object_id = data.id;
                this.newAddresDetails = null;
                this.SHOW_SUCCESS('Помещение успешно добавлено');
            }catch(err){
                if(undefined !== err.response.data.error){
                    this.SHOW_ERROR(err.response.data.error);
                }else{
                    this.SHOW_ERROR('Ошибка сохранения помещения');
                }
                console.log(err);
            }

        },
        async loadHouseObjectPremises(){
            let { data } = await organizationApi.houseObjectPremises(
                this.ID_WORK_SPACE, 
                this.ORGANIZATION_ID, 
                this.selected_house_address_object_id.housingFundObject_fiasHouseGUID
            );
            this.selected_house_address_object_premise_id = [];
            this.selected_house_address_object_premise_id.splice(0, this.selected_house_address_object_premise_id.length, ...data);
        },
        async searchHouseObjects(search, appendItems = false){
            try{
                this.searchHouseObjectLoading = true;
                let { data } = await organizationApi.houseObjectsIndex(this.ID_WORK_SPACE, this.ORGANIZATION_ID, search);
                if( ! appendItems){
                    this.houseObjects.splice(0, this.houseObjects.length);
                }
                this.houseObjects.push(...data.data);
                this.metaSearchHouseObjects = {...data, data: null};
            }catch(err){
                console.log(err);
            }finally{
                this.searchHouseObjectLoading = false;
            }
        },
        async loadNextHouseObjects(){
            if(this.metaSearchHouseObjects.next_page_url){
                await this.searchHouseObjects({...this.getSearchParamsHouseObjects(), page: ++this.metaSearchHouseObjects.current_page}, true)
            }
        },

        getSearchParamsHouseObjects(){
            return {address: this.searchHouseObject};
        },

        onCloseDialog(){
            const obj = {
                first_name: '',
                last_name: '',
                middle_name: '',
                house_address_object_id: null,
                judgment_number: null,
                date_of_judgment: null
            }
            this.editedItem = {...obj};
            // this.$refs.form.reset();
            this.houseObjects.splice(0, this.houseObjects.length);
            this.dialog = false;
        },
        showSaveConfirmDialog(text){
            this.dialogSaveConfirm.text = text;
            this.dialogSaveConfirm.status = true;
        },
        closeDialogSaveConfirm(){
          this.dialogSaveConfirm.status = false;
          this.dialogSaveConfirm.text = '';
        },
        async onValidateAndSaveDebtor(){
            if( ! this.$refs.form.validate() ){
                return Promise.reject();
            }
            if(this.editedItem.date_of_judgment === null){
                let confirmText = "Вы не заполнили дату судебного решения. Для корректной работы сервиса по поиску должников из числа запросов требуется указывать дату судебного решения.";
                this.showSaveConfirmDialog(confirmText);
                return Promise.reject();
            }
            if(this.editedItem.id){
                await this.onUpdateDebtor();
            }else{
                await this.onSaveDebtor();
            }
        },

        async onEditDebtor(id){
            let {data} = await organizationApi.socialDebtorsShow(this.ID_WORK_SPACE, this.ORGANIZATION_ID, id);
            this.dialog = true;
            this.searchHouseObjects(this.getSearchParamsHouseObjects()).then(() => {
                this.houseObjects.push({...data.house_address_object, full_address: data.house_address_object.housingFundObject_address})
            });
            this.selected_house_address_object_id = {...data.house_address_object, full_address: data.house_address_object.housingFundObject_address};
            this.editedItem = data;
            this.loadHouseObjectPremises();
        },

        async onSaveDebtor(){
            this.closeDialogSaveConfirm();
            if( ! this.$refs.form.validate() ){
                return Promise.reject();
            }
            try{
                await organizationApi.socialDebtorsStore(this.ID_WORK_SPACE, this.ORGANIZATION_ID, this.editedItem);
                this.loadDebtors();
                this.onCloseDialog();
                this.SHOW_SUCCESS('Успешно добавлен');
            }catch(err){
                console.log(err);
                this.SHOW_ERROR('Ошибка создания');
            }
        },

        async onUpdateDebtor(){
            this.closeDialogSaveConfirm();
            if( ! this.$refs.form.validate() ){
                return Promise.reject();
            }
            try{
                await organizationApi.socialDebtorsUpdate(this.ID_WORK_SPACE, this.ORGANIZATION_ID, this.editedItem.id, this.editedItem);
                this.loadDebtors();
                this.onCloseDialog();
                this.SHOW_SUCCESS('Успешно обновлен');
            }catch(err){
                console.log(err);
                this.SHOW_ERROR('Ошибка создания');
            }
        },

        onPaginate(pageNumber){
            this.meta.current_page = pageNumber;
            this.loadDebtors();
        },
        async loadDebtors(){
            if( ! this.ORGANIZATION_ID ){
                return ;
            }
            let { data } = await organizationApi.socialDebtorsIndex(this.ID_WORK_SPACE, this.ORGANIZATION_ID, {params: {page: this.meta.current_page, ...this.filter}});
            this.debtors.splice(0, this.debtors.length, ...data.data);
            this.meta = {...data, data: null}
        },
        closeDelete(){
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.deleteHousePersonDebtorId = null;
            });
        },
        onDeleteConfirm(housePersonDebtorId){
            this.dialogDelete = true;
            this.deleteHousePersonDebtorId = housePersonDebtorId;
        },
        async onDelete(housePersonDebtorId){
            try{
                let {data} = await organizationApi.socialDebtorsDelete(this.ID_WORK_SPACE, this.ORGANIZATION_ID, housePersonDebtorId);
                this.SHOW_SUCCESS(data);
                this.loadDebtors();
                this.closeDelete();
            }catch(err){
                console.log(err);
                this.SHOW_ERROR('Ошибка удаления');
            }
        }
    },

    computed: {
        debtorsItems(){
            return this.debtors.map(debtor => {
                return {
                    ...debtor,
                    fio : debtor.full_name,
                    address: debtor.house_address_object.full_address
                };
            });
        },
        ...mapGetters( 'workspace', ['ID_WORK_SPACE', 'ORGANIZATION_ID']),
        ...mapGetters('user', ['IS_ADMIN']),
    }
}
</script>